import {
	DROP_AB_MAX_ARMS,
	DropCardVariant,
} from '../../constants/dropCardVariants';

const KNOWN_VARIANTS = new Set<string>(Object.values(DropCardVariant));

const isDropCardVariant = (value: unknown): value is DropCardVariant =>
	typeof value === 'string' && KNOWN_VARIANTS.has(value);

// A grid's Directus `variants` checkboxes, as the layouts to serve. Directus
// stores the field as CSV, which GraphQL returns as a list and older payloads
// may return as the raw string. Values the grid does not support are dropped,
// so an option removed from a grid in code cannot break a page still
// selecting it. Nothing selected, or nothing usable, means the original
// layout alone, so grids saved before the field existed are unchanged.
export const getDropCardVariants = (
	raw: unknown,
	supported: readonly DropCardVariant[]
): DropCardVariant[] => {
	const values = typeof raw === 'string' ? raw.split(',') : raw;

	if (!Array.isArray(values)) {
		return [DropCardVariant.Original];
	}

	const variants = [
		...new Set(
			values
				.map((value) => (typeof value === 'string' ? value.trim() : value))
				.filter(isDropCardVariant)
				.filter((variant) => supported.includes(variant))
		),
	].slice(0, DROP_AB_MAX_ARMS);

	return variants.length ? variants : [DropCardVariant.Original];
};
